import * as t from 'io-ts';
import {chain} from 'lodash';

import {makeEnumTypeGuard} from '../../../libs/shared/helpers/src/typescript/enumHelpers';
import {makeEnumRuntimeType} from './apiTypes';

export enum ChannelTypesEnum {
  CUSTOM = 'custom',
  // Legacy, we shouldn't have any active channels of that type.
  LAYER_ANON = 'layer_anon',
  FACEBOOK = 'facebook',
  GMAIL = 'gmail',
  GOOGLE_PLAY = 'google_play',
  // Legacy, we shouldn't have any active IMAP channels.
  IMAP = 'imap',
  INTERCOM = 'intercom',
  FORM = 'form',
  OFFICE365 = 'office365',
  SMOOCH = 'smooch',
  SMTP = 'smtp',
  TALKDESK = 'talkdesk',
  TRULY = 'truly',
  TWILIO = 'twilio',
  TWILIO_WHATSAPP = 'twilio_whatsapp',
  TWITTER = 'twitter',
  TWITTER_DM = 'twitter_dm',
  YALO_WHATSAPP = 'yalo_wha',
  FRONT_CHAT = 'front_chat',
  FRONT_MAIL = 'front_mail',
}
export const RChannelType = makeEnumRuntimeType(ChannelTypesEnum);
export const isChannelType = makeEnumTypeGuard(ChannelTypesEnum);

export enum ChannelEmailThreadingModesEnum {
  GMAIL = 'gmail',
  OFFICE365 = 'office365',
  REGULAR = 'regular',
  SUBJECT = 'subject',
  OFFICE365_SUBJECT = 'office365_subject',
  SUBJECT_ONLY = 'subject_only',
  DISABLED = 'disabled',
}

export interface AutoBcc extends t.TypeOf<typeof RAutoBcc> {}
export const RAutoBcc = t.readonly(
  t.type({
    isEnabled: t.boolean,
    handles: t.readonlyArray(t.string),
  }),
);

export function parseAutoBcc(src: any): AutoBcc {
  if (!src) {
    return {isEnabled: false, handles: []};
  }

  return {
    isEnabled: Boolean(src.enabled),
    handles: chain(src.val || '')
      .split(/;|,/)
      .map((v) => v.trim())
      .compact()
      .value(),
  };
}
